var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 107.23 134.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#009aff;}.e{fill:#3671a1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M105,0h-13.42c-1.23,0-2.23,1-2.23,2.23V15.64c0,1.23,1,2.23,2.23,2.23h13.42c1.23,0,2.23-1,2.23-2.23V2.23c0-1.23-1-2.23-2.23-2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M105,26.81h-13.42c-1.23,0-2.23,1-2.23,2.23v11.43c-8.44-7.56-19.28-12.47-31.23-13.47-1.49-.12-2.99-.19-4.51-.19s-2.95,.06-4.4,.18C21.67,29.22,0,52.3,0,80.43s21.61,51.14,49.1,53.43c1.49,.12,2.99,.19,4.51,.19s2.95-.06,4.4-.18c12-.98,22.88-5.9,31.35-13.48v11.43c0,1.23,1,2.23,2.23,2.23h13.42c1.23,0,2.23-1,2.23-2.23V29.04c0-1.23-1-2.23-2.23-2.23ZM58.02,115.9c-1.42,.17-2.87,.27-4.35,.27h-.05c-1.53,0-3.04-.09-4.51-.28-17.62-2.22-31.23-17.25-31.23-35.46s13.68-33.31,31.35-35.48c1.44-.18,2.91-.27,4.4-.27h.07c1.5,0,2.99,.1,4.44,.28,17.62,2.23,31.23,17.25,31.23,35.47s-13.68,33.3-31.35,35.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M89.36,120.39v11.38c.97-.67,1.91-1.37,2.84-2.09,5.98-4.7,11.09-10.47,15.03-17.01v-32.23c0,15.88-6.9,30.14-17.87,39.96Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbol);
export default __webpack_public_path__ + "static/media/symbol.4cf726ff358c2b2087ab6c50b6e2c447.svg";
export { ForwardRef as ReactComponent };